export default __webpack_public_path__ + "static/media/smallDelete.c5dc6b98.svg";